export const getMenuItemIdentifier = ({ articleId, pageId, linkUrl }) => articleId || pageId || linkUrl;

const toTreeItem = ({ items, ...menuItem }) => ({
  [getMenuItemIdentifier(menuItem)]: {
    id: getMenuItemIdentifier(menuItem),
    data: menuItem,
    isExpanded: true,
    children: items?.map(getMenuItemIdentifier) || [],
    hasChildren: items?.length > 0,
    isChildrenLoading: false,
  },
});

const extractTreeItems = (menuItems = []) =>
  menuItems?.reduce(
    (acc, menuItem) => ({
      ...acc,
      ...toTreeItem(menuItem),
      ...extractTreeItems(menuItem?.items),
    }),
    {},
  );

export const convertToTree = (menu) => ({
  rootId: 'root',
  items: {
    ...extractTreeItems(menu?.items || []),
    root: {
      id: 'root',
      hasChildren: menu?.items?.length > 0,
      children: menu?.items?.map(getMenuItemIdentifier) || [],
    },
  },
});

export const treeNodeToMenuItem = (node, tree) => ({
  ...node.data,
  items: node.children.map((id) => treeNodeToMenuItem(tree.items[id], tree)),
});

export const addPageToTree = (page, tree) => {
  const key = getMenuItemIdentifier({ pageId: page.id, linkUrl: page.slug });
  const setId = page.contentId || page.id;

  return {
    ...tree,
    items: {
      ...tree.items,
      [key]: {
        id: key,
        data: {
          title: page.title,
          isVisible: true,
          linkUrl: null,
          pageId: setId,
          articleId: null,
          items: [],
        },
        isExpanded: true,
        children: [],
        hasChildren: false,
        isChildrenLoading: false,
      },
      [tree.rootId]: {
        ...tree.items[tree.rootId],
        children: [...tree.items[tree.rootId].children, key],
        hasChildren: true,
        isExpanded: true,
      },
    },
  };
};

export const getItemIdsToRemove = (itemToRemove, tree) => [
  itemToRemove.id,
  ...itemToRemove.children.reduce((acc, id) => [...acc, ...getItemIdsToRemove(tree.items[id], tree)], []),
];

export const deleteItemFromTree = (itemToRemove, tree) => {
  const itemIdsToRemove = new Set(getItemIdsToRemove(itemToRemove, tree));

  const newItems = Object.entries(tree.items).reduce((acc, [id, item]) => {
    if (itemIdsToRemove.has(id) || !item) {
      return {
        ...acc,
        [id]: null,
      };
    }

    const newChildren = item.children.filter((_id) => !itemIdsToRemove.has(_id));

    return {
      ...acc,
      [id]: {
        ...item,
        children: newChildren,
        hasChildren: newChildren.length > 0,
      },
    };
  }, {});

  return {
    ...tree,
    items: newItems,
  };
};
